<template>
  <div>
    <v-checkbox
      class="dynamic_check_box"
      ref="control"
      v-if="l_visible"
      :value="currentValue"
      :label="l_label"
      :loading="loading"
      @change="
        val => {
          setDirty(true);
          update(val);
        }
      "
      v-bind:class="{
        large: large,
      }"
      :disabled="jeDisabled"
      :hide-details="hideDetails"
    ></v-checkbox>
  </div>
</template>

<script>
import { dynamicControlMixin } from '../../mixins/dynamicControlMixin';

export default {
  mixins: [dynamicControlMixin],
  props: {
    value: [Number], //aj ked sem dam number tak vuetify vyplna boolean, formatujem si to neskor
    loading: Boolean,
    large: Boolean,
    disabled: Boolean,
  },
  computed: {
    jeDisabled(){
      return this.isDisabled || this.disabled;
    }
  },
  watch: {
    value(val) {
      this.update(val);
    },
  },
  data() {
    return {
      isLoading: false,
      currentValue: this.value ? 1 : 0,
    };
  },
  methods: {
    readData(config) {
      this.currentValue = null;
      //vyjebany hack, lebo inak to zial nejde
      setTimeout(() => {
        this.currentValue = config.controlValue ? 1 : 0;
        this.$emit('input', this.currentValue);
      }, 100);
    },
    update(newVal) {
      let newValInt = newVal ? 1 : 0;
      if (newVal === this.currentValue) return;
      this.currentValue = newValInt;
      this.$emit('input', newValInt);
      this.saveValue(newValInt);
    },
  },
};
</script>
